import { render, staticRenderFns } from "./AccountSettingSport.vue?vue&type=template&id=21ca8158&"
import script from "./AccountSettingSport.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports